// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"679":"f8e7fe77","745":"85d73d44","982":"cd106350"}[chunkId] + ".css";
};